import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <div className="w-20 h-20 rounded-full bg-background-100 flex items-center justify-center mb-6">
        <i className="ri-error-warning-line text-3xl text-foreground-300"></i>
      </div>
      <h1 className="font-heading text-4xl font-bold text-foreground-900 mb-2">404</h1>
      <p className="text-base text-foreground-500 mb-2">页面未找到</p>
      <p className="text-sm text-foreground-400 mb-6">您访问的页面不存在或已被移除</p>
      <Link
        to="/"
        className="px-6 py-2.5 rounded-lg bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
      >
        返回首页
      </Link>
    </div>
  );
}